var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"trendsChartConatiner",staticStyle:{"width":"100%","height":"500px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }